import { IObservableArray } from "mobx";
import { Domino } from "./DominoesMassive";

/** Shuffle the massive */
export const shuffleArrayElements = (
  array: string[] | IObservableArray<Domino>
): void => {
    for (let i = array.length - 1; i > 0; i--) {
        let j: number = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
};
